<template>
    <div :class="[colorClasses.root, 'toast', 'bg-white', 'text-default']" role="alert" aria-live="assertive" aria-atomic="true" style="opacity: 1; max-width: none;">
        <div :class="[colorClasses.header, 'toast-header']">
            <slot name="headerStart"></slot>
            <span class="font-weight-semibold mr-auto" v-html="title"></span>
            <slot name="headerElements"></slot>
        </div>
        <slot></slot>
        <div class="toast-footer border-top d-flex align-items-center justify-content-between px-3 py-2" v-if="$slots.footer">
            <slot name="footer"></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: "AppToast",
    props: {
        title: {
            type: String,
            required: true
        },
        color: {
            type: String,
            default: 'light'
        }
    },
    computed: {
        colorClasses() {
            const map = {
                light: { root: '', header: 'text-default bg-light border-bottom' },
                success: { root: 'border-success', header: 'alpha-success text-success-800 border-bottom-success' },
                primary: { root: 'border-primary', header: 'alpha-primary text-primary-800 border-bottom-primary' },
                danger: { root: 'border-danger', header: 'alpha-danger text-danger-800 border-bottom-danger' },
                warning: { root: 'border-warning', header: 'alpha-warning text-warning-800 border-bottom-warning' },
                info: { root: 'border-info', header: 'alpha-info text-info-800 border-bottom-info' }
            }

            return map[this.color] ?? map.light;
        }
    }
}
</script>